var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#D4137B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_470_1846",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 36,
    height: 36
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_470_1846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 36C11.175 36 10.4688 35.7063 9.88125 35.1188C9.29375 34.5312 9 33.825 9 33V15C9 14.175 9.29375 13.4688 9.88125 12.8813C10.4688 12.2938 11.175 12 12 12H36C36.825 12 37.5312 12.2938 38.1187 12.8813C38.7062 13.4688 39 14.175 39 15V33C39 33.825 38.7062 34.5312 38.1187 35.1188C37.5312 35.7063 36.825 36 36 36H12ZM24 25.5L36 18V15L24 22.5L12 15V18L24 25.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.ada4a23f100a0a58e103d8a4d32f3538.svg";
export { ForwardRef as ReactComponent };